import { Button, ButtonProps } from 'common/Button'
import { PopupDialog, PopupDialogProps } from 'common/PopupDialog'
import { PopupDialogContent } from 'common/PopupDialog/PopupDialogContent'
import { ErrorCodes } from 'config/errorCodes'
import { useStore } from 'lib/store'
import { NSFW_EVENT } from 'lib/tracking/types'
import { observer } from 'mobx-react-lite'
import { Post } from 'models/Post'
import { MouseEventHandler, useState } from 'react'
import { ReportMenu } from 'shared/ReportMenu'

export interface PostCardMoreMenuProps extends PopupDialogProps {
  post: Post
}

const _PostCardMoreMenu: React.FC<PostCardMoreMenuProps> = ({ isOpen, onIgnore, post, css }) => {
  const store = useStore()
  const [reportMenuIsOpen, setReportMenuIsOpen] = useState(false)

  const handleDeletePostClick = () => {
    store.ui.setApplicationError(ErrorCodes.DELETE_POST, {
      primary: (
        <Button theme="primary" onClick={() => post.deletePost()}>
          Delete
        </Button>
      )
    })
  }

  return (
    <>
      <PopupDialog isOpen={isOpen} onIgnore={onIgnore}>
        <PopupDialogContent css={css}>
          {post.isOwner && (
            <Button theme="primary" onClick={handleDeletePostClick}>
              Delete Post
            </Button>
          )}
          {store.user.account && !post.isOwner && (
            <Button theme="danger" onClick={() => setReportMenuIsOpen(true)}>
              Report
            </Button>
          )}
        </PopupDialogContent>
      </PopupDialog>
      <ReportMenu
        isOpen={reportMenuIsOpen}
        onIgnore={() => setReportMenuIsOpen(false)}
        post={post}
      />
    </>
  )
}

export const PostCardMoreMenu = observer(_PostCardMoreMenu)
